<template>
    <div class="HideView" :class="{ 'HideView--hidden': value }" @click="onShow()">
        <div class="HideViewButton" @click="$emit('click', $event)">
            <svg-view v-if="!value" name="eye-hide"></svg-view>
            <svg-view v-else name="eye-show"></svg-view>
        </div>
    </div>
</template>

<script>
export default {
    name: "HideView",
    props: {
        value: { type: Boolean, default: false }
    },
    methods: {
        onShow() {
            this.$emit("input", !this.value);
        }
    }
};
</script>

<style scoped lang="less">
@import "~styles/const.less";

@r: .HideView;

@{r} {
    position: absolute;
    background: white;
    top: 5px;
    left: -50px;
    z-index: 1;
    border-radius: 50%;
    cursor: pointer;

    &Button {
        display: block;
        width: 30px;
        height: 30px;
        transition: opacity .3s ease;

        &:hover {
            opacity: .7;
        }

        svg {
            width: 100%;
            height: 100%;
            display: inline-block;
            transition: fill 0.2s;
            fill: @color-black;
        }
    }
}
</style>
